<template>
  <div class="create-batch-check-order-job">
    <div class="content" style="min-height: 0">
      <a-tabs default-active-key="DeliveryInformation" @change="changeTabs">
        <a-tab-pane key="DeliveryInformation" :tab="$t(`form.DeliveryInformation`)"></a-tab-pane>
        <a-tab-pane key="ProductInfo" :tab="$t(`form.ProductInfo`)"></a-tab-pane>
      </a-tabs>
    </div>
    <div class="content-overflow">
      <section class="left-div fixContent" :style="{ height: scrollHeight }">
        <a-form-model ref="ruleForm" :model="formData">
          <div id="DeliveryInformation" class="modalBox">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                <span>{{ $t('form.DeliveryInformation') }}</span>
                <!-- <a-tag
                  style="
                    font-size: 12px;
                    font-weight: normal;
                    margin-left: 10px;
                  "
                  >{{ formData.status | statusFilter }}</a-tag
                > -->
              </div>
            </div>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.ShippingWarehouse`)">
                  <a-input
                    allow-clear
                    v-model.trim="formData.TrackingSheetNo"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.ShippingWarehouse`)"
                    disabled
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.DeliveryTime`)">
                  <a-input
                    allow-clear
                    v-model.trim="formData.TrackingSheetNo"
                    :placeholder="$t(`form.PleaseEnter`) + $t(`form.DeliveryTime`)"
                    disabled
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t(`form.DeliveryOrderNo`)">
                  <a-input
                    v-model="formData.receiverMobile"
                    :placeholder="$t(`form.DeliveryOrderNo`)"
                    disabled
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
        </a-form-model>
        <div id="ProductInfo" class="modalBox">
          <a-form-model>
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                {{ $t('form.ProductInfo') }}
              </div>
            </div>
            <a-row>
              <div class="table-wrapper" style="margin-top: 10px">
                <!--每个列的宽度必须比列名总长度大才能使表格所有列对齐，留一个列不设置宽度  :rowSelection="{selectedRowKeys: selectedRowKeys}"-->
                <a-table
                  :columns="columns"
                  :dataSource="tableData"
                  bordered
                  size="middle"
                  :loading="tableLoading"
                  :pagination="false"
                  :scroll="{ x: 1000 }"
                  :rowKey="
                    (record, index) => {
                      return index
                    }
                  "
                >
                  <span slot="ProductBarcode">
                    <i class="red">*</i>
                    &nbsp;{{ $t(`form.ProductBarcode`) }}
                  </span>
                  <span slot="StockQuantity">
                    <i class="red">*</i>
                    &nbsp;{{ $t(`form.StockQuantity`) }}
                  </span>
                  <span slot="boxSize">
                    <i class="red">*</i>
                    &nbsp;{{ $t(`form.BoxSize`) }}
                  </span>
                  <span slot="casesNum">
                    <i class="red">*</i>
                    &nbsp;{{ $t(`form.CasesNumber`) }}
                  </span>
                </a-table>
              </div>
            </a-row>
          </a-form-model>
        </div>
      </section>
    </div>

    <div class="content" style="min-height: 0">
      <a-row type="flex" justify="center">
        <a-col v-if="formData.status !== 'CANCEL'">
          <a-row type="flex" justify="start" :gutter="16">
            <a-button type="default" @click="backForm">{{ $t(`form.Back`) }}</a-button>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapState } from 'vuex'
import { getCookie } from '@/common/cookie'
var _self = {}
export default {
  name: 'deliveryOrderDetails',
  data() {
    return {
      purchaseOrderId: '',
      columns: [
        {
          align: 'center',
          dataIndex: 'caseNo',
          width: 120,
          title: this.$t(`form.BoxNumber`),
          scopedSlots: {
            customRender: 'caseNo',
          },
        },
        {
          title: this.$t(`form.ProductName`),
          align: 'center',
          dataIndex: 'productName',
          width: 120,
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          slots: { title: 'ProductBarcode' },
          align: 'center',
          dataIndex: 'barcode',
          width: 120,
          scopedSlots: {
            customRender: 'barcode',
          },
        },
        {
          title: this.$t(`form.CommoditySpecification`),
          align: 'center',
          dataIndex: 'productStyle',
          width: 120,
          scopedSlots: {
            customRender: 'productStyle',
          },
        },
        {
          align: 'center',
          dataIndex: 'BoxSize',
          width: 120,
          slots: { title: 'boxSize' },
          scopedSlots: {
            customRender: 'BoxSize',
          },
        },
        {
          title: this.$t(`form.Unit`),
          align: 'center',
          dataIndex: 'caseUnit',
          width: 120,
          scopedSlots: {
            customRender: 'caseUnit',
          },
        },
        {
          slots: { title: 'casesNum' },
          align: 'center',
          dataIndex: 'CasesNumber',
          width: 120,
          scopedSlots: {
            customRender: 'CasesNumber',
          },
        },
        {
          title: this.$t(`form.DeliveryQuantity`),
          align: 'center',
          dataIndex: 'DeliveryQuantity',
          width: 120,
        },
      ],
      // 表格数据
      tableData: [],
      // 表格loading
      tableLoading: false,
      formData: {},
      sessionId: '',
    }
  },
  mounted() {
    this.sessionId = getCookie('d_session_id')
    this.getList()
  },
  computed: {
    ...mapState(['userSession']),
    scrollHeight() {
      let height = window.innerHeight - 300
      return height * this.$store.state.rate + 'px'
    },
  },
  watch: {
    'formData.changeWarehouseType'(newVal) {
      if (newVal === 'STRATEGY_WAREHOUSE') {
        this.formData.chooseShippingType = 'BEST_SHIIPING'
      }
    },
  },
  filters: {
    statusFilter(val) {
      const statusMap = {
        WAIT_CHECK: _self.$t(`form.Pending`),
        WAIT_INBOUND: _self.$t(`form.WaitInbound`),
        PART_INBOUND: _self.$t(`form.PART_INBOUND`),
        FINISH: _self.$t(`form.Success`),
        CANCEL: _self.$t(`form.Abolished`),
      }
      return statusMap[val]
    },
  },
  methods: {
    getList() {
      _self = this
      // this.getProvinceList();
      if (this.$route.query.id) {
        this.purchaseOrderId = this.$route.query.id
        http({
          instance: _self,
          url: api.purchaseOrderDetail,
          type: 'post',
          data: {
            purchaseOrderId: this.purchaseOrderId,
          },
          success: (res) => {
            this.tableData = res.result.purchaseOrderItemResVOS
            this.formData = res.result
            _self.getWarehouseList()
            _self.keyword = ''
            this.$forceUpdate()
            this.getOrderProcess()
          },
        })
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    backForm() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  // display: flex;
  // justify-content: space-between;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
</style>
